import { render, staticRenderFns } from "./UniversityMail.vue?vue&type=template&id=183e2e3b&"
import script from "./UniversityMail.vue?vue&type=script&lang=js&"
export * from "./UniversityMail.vue?vue&type=script&lang=js&"
import style0 from "./UniversityMail.vue?vue&type=style&index=0&id=183e2e3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports